import { Fragment } from 'react';
import { Loading } from '../../components/Loading';
import { ErrorMessage } from '../../GlobalComponents/ErrorMessage';
import { Flex } from '../../GlobalComponents/Flex';


export const QueryResult = ({
	data,
	error,
	loading,
	children
}: QueryResultProps): JSX.Element => {
	return (
		<Fragment>
			{error && <ErrorMessage error={error} dismissible={false} />}
			{loading && (
				<Flex
					$alignItems="center"
					$justifyContent="center"
					$padding="12px"
					$margin='60px 0'
				>
					<Loading  />
				</Flex>
			)}
			{!loading && data && <>{children}</>}
		</Fragment>
	);
};

interface QueryResultProps {
	data: any;
	error?: any;

	loading: boolean;
	children: any;
}


